import { render, staticRenderFns } from "./TopicMoreRole.vue?vue&type=template&id=3c26e038&scoped=true"
import script from "./TopicMoreRole.vue?vue&type=script&lang=js"
export * from "./TopicMoreRole.vue?vue&type=script&lang=js"
import style0 from "./TopicMoreRole.vue?vue&type=style&index=0&id=3c26e038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c26e038",
  null
  
)

export default component.exports